// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PackageCompositionDetailResponse

export type PackageCompositionDetailApiResponse = {
	id: number;
	activityId: string | null;
	offerId: string | null;
	guestPriceId: string | null;
};

export type PackageCompositionDetail = {
	id: number;
	activityId: string | null;
	offerId: string | null;
	guestPriceId: string | null;
};

export function hydratePackageCompositionDetail(data: PackageCompositionDetailApiResponse): PackageCompositionDetail {
	return { ...data };
}